<template>
    <span>{{ valorFormatado }}</span>
</template>

<script>
export default {
    name: 'FormatadorMoeda',
    props: {
        valor: {
            type: Number,
        },
        casasDecimais: {
            type: Number,
        }
    },
    computed: {
        valorFormatado() {
            const numArr = this.valor.toFixed(this.casasDecimais).split('.')
            return numArr[0].split('').reverse().reduce(function (acc, num, i) {
                const separator = i && !(i % 3) ? '.' : ''
                return num === '-' ? acc : num + separator + acc
            }, '') + ',' + numArr[1]
        }
    }
}
</script>